import React, { useState } from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { LiaAwardSolid } from 'react-icons/lia'; // Assuming you're using react-icons for icons
import { toast } from 'react-toastify';
import ProfileComplete from './Popup/ProfileComplete';

const CertificateLink = ({ lab, certificate, Certificate_link, useIcon = false, className = "mx-2 text-primary small", hideLabName = false, withExternalLinkIcon= false ,displaycertificate = true}) => {
  const [profileModalOpen,setProfileModalOpen] = useState(false)
  return (
    <>
    <ProfileComplete profileModalOpen={profileModalOpen} setProfileModalOpen={setProfileModalOpen}/>
    {displaycertificate?<>
    {Certificate_link ? (
      <a
        href={Certificate_link}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
      >
        {useIcon ? <LiaAwardSolid /> : `${!hideLabName ? `${lab}: ` : ''}${certificate}`}
        {withExternalLinkIcon ? <FaExternalLinkAlt className='ml-1' />:""}
      </a>
    ) : !useIcon?(
      <a
        target="_blank"
        rel="noopener noreferrer"
        className={className}
      >
        {lab === "NON"?"NON-CERTIFIED":certificate}
      </a>
    ):null}
    </>:
    <>
    <span className={className}>
    {/* {useIcon ? <LiaAwardSolid onClick={() => toast.error("Please Update your KYC.")}/> : `${lab}: ***********`} */}
    {useIcon ? <LiaAwardSolid onClick={() => setProfileModalOpen(true)}/> : `${!hideLabName ? `${lab !== "NON"?`${lab}: ***********`:"NON-CERTIFIED"}` : `${lab !== "NON"?`***********`:"NON-CERTIFIED"}`}`}
    </span>
    </>
    }
    </>
  );
};

export default CertificateLink;
